// removed by extract-text-webpack-plugin
module.exports = {"icon":"style__icon___1WPkA","right-text":"style__right-text___hndch","left-text":"style__left-text___33BrR","button-icon":"style__button-icon___OZ25H","container":"style__container___1IVjm","stacked-icon":"style__stacked-icon___5Dbeg","multiple_date-icon":"style__multiple_date-icon___YGBwX"};


//////////////////
// WEBPACK FOOTER
// ./components/FontIcon/style.scss
// module id = 1194
// module chunks = 0